import React from "react";

import {
  Box,
  Input,
  Select,
  DialogContent,
  MenuItem,
  Typography,
} from "@material-ui/core";

export default function PdfPreferences(props) {
  const t = props.t;

  const minmax = (value, min, max) => {
    if (parseInt(value) < min || isNaN(value)) return min;
    else if (parseInt(value) > max) return max;
    else return value;
  };

  return (
    <Box mb={1}>
      <DialogContent>
        {/* Select Color */}
        <Box mb={1}>
          <Select
            open={props.colorOpen}
            onClose={props.handleColorClose}
            onOpen={props.handleColorOpen}
            value={props.color}
            onChange={props.handleColorChange}
            disabled={props.disabled}
          >
            <MenuItem value={"default"}>{t("color")}</MenuItem>
            <MenuItem value={"grey"}>{t("grey")}</MenuItem>
          </Select>
        </Box>
        {/* Input Quality */}
        <Box mb={2}>
          <Typography fontWeight="fontWeightBold">
            {t("quality")} (%){" "}
          </Typography>
          <Input
            margin="dense"
            type="number"
            placeholder={props.quality.toString() + "%"}
            onChange={props.handleQualityChange}
            inputProps={{
              step: 10,
              min: 10,
              max: 100,
              type: "number",
            }}
            disabled={props.disabled}
            onKeyDown={(e) => {
              e.preventDefault();
            }}
            defaultValue={100}
          />
        </Box>

        {/* Input Pages */}
        <Typography fontWeight="fontWeightBold">{t("pages")}: </Typography>
        <Input
          className="input"
          type="number"
          inputProps={{
            min: props.defaultFirstPage,
            max: props.lastPage,
          }}
          placeholder={"1"}
          onChange={props.handleFirstPage}
          onKeyUp={(e) => {
            e.target.value = minmax(
              e.target.value,
              props.defaultFirstPage,
              props.lastPage
            );
            props.handleFirstPage(e);
          }}
          disabled={props.disabled}
          defaultValue={props.defaultFirstPage}
        />
        <Input
          className="input"
          type="number"
          inputProps={{
            min: props.firstPage,
            max: props.defaultLastPage,
          }}
          placeholder={props.defaultLastPage.toString()}
          onChange={props.handleLastPage}
          onKeyUp={(e) => {
            e.target.value = minmax(
              e.target.value,
              props.firstPage,
              props.defaultLastPage
            );
            props.handleLastPage(e);
          }}
          defaultValue={props.defaultLastPage}
          disabled={props.disabled}
        />
      </DialogContent>
    </Box>
  );
}